import { rest } from '@0xtorch/core'
import { z } from 'zod'
import type { ClientCallParameters } from './create'

const accountInfoSchema = z.object({
  /** number of lamports assigned to this account, as a u64 */
  lamports: z.number().int(),
  /** base-58 encoded Pubkey of the program this account has been assigned to */
  owner: z.string(),
  /** associated with the account, either as encoded binary data or JSON format {<program>: <state>} - depending on encoding parameter */
  data: z.unknown(),
  /** boolean indicating if the account contains a program (and is strictly read-only) */
  executable: z.boolean(),
  /** the epoch at which this account will next owe rent, as u64 */
  rentEpoch: z.number().int(),
})

export type AccountInfo = z.infer<typeof accountInfoSchema>

const schema = z.object({
  jsonrpc: z.literal('2.0'),
  result: z.object({
    value: accountInfoSchema.nullable(),
  }),
  id: z.number(),
})

type GetAccountInfoParameters = ClientCallParameters & {
  address: string
}

export const getAccountInfo = async ({
  endpoint,
  headers,
  address,
}: GetAccountInfoParameters): Promise<AccountInfo | undefined> => {
  const response = await rest(endpoint, {
    fetchOptions: {
      method: 'POST',
      headers: {
        ...headers,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        jsonrpc: '2.0',
        id: 1,
        method: 'getAccountInfo',
        params: [
          address,
          {
            encoding: 'jsonParsed',
          },
        ],
      }),
    },
    schema: schema,
  })
  return response.result.value ?? undefined
}
